<template>
  <div class="home-container">
    <el-header class="bgColer" height="42px" style="display:flex;justify-content: space-between;">
      <div style="display:flex;align-items: center;">
        <img src="../../../assets/images/qiye.png" alt  style="width: 23px;height: 23px;margin-right: 8px;"/>
        <span class="text">{{companyName}}</span>
        <span style="color:#fff;" v-if="tenantList.length>1">（{{createTenantName}}）</span>
      </div>
      <div class="headerRight">
        <div v-if="tenantList.length>1" style="margin-right:8px">
          <el-button type="text" @click.native="orgChange()">
            <i class="fa fa-exchange" aria-hidden="true" style="color:#fff"></i>
            <span style="color:#fff">&nbsp;切换板块</span>
          </el-button>
        </div>
        <div class="username mesbox" style="margin-right:18px;" @click="xiaoxiFn">
          <i class="el-icon-message-solid"></i>
          <el-badge :value="msgNum" class="item" :hidden="msgNum==0">
            消息通知
          </el-badge>
        </div>
        <el-dropdown class="ID-dropdown" style="margin-right:18px;">
          <span class="el-dropdown-link">
            <i class="el-i-down el-icon-sort"></i>
            <span class="ID-change">切换账号</span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="changeData.length==0">暂无可切换账号</el-dropdown-item>
            <el-dropdown-item @click.native="changeID(item.bind_user_id)" v-for="(item,index) in changeData" :key="index" v-else>
              <!-- <div style="display:flex">
                <div style="width:160px"><i class="el-icon-user-solid"></i>{{item.user_account}}</div>&nbsp;&nbsp;(&nbsp;&nbsp;<div>{{item.tenant_name}}</div>&nbsp;&nbsp;-&nbsp;&nbsp;<div>{{item.user_name}}</div>&nbsp;&nbsp;)
              </div> -->
              <div style="display:flex;">
                <div style="height:50px;padding-top:15px"><i class="el-icon-user-solid" style="font-size:25px"></i></div>
                <div style="height:50px">
                  <div style="height:25px;font-size:14px;font-weight:600">{{item.user_account}}</div>
                  <div style="height:25px;font-size:12px;color:#666">{{item.tenant_name}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.user_name}}</div>
                </div>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown class="my-dropdown">
          <span class="el-dropdown-link">
            <!-- 头像 用户名称 -->
            <img class="avatar" src="../../../assets/images/loginer.png" alt />
            <span class="username">{{name}}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <!--  slot="dropdown" 插槽 -->
          <el-dropdown-menu slot="dropdown" v-if="createTenantCode">
            <el-dropdown-item icon="el-icon-edit-outline" @click.native="setting()">修改密码</el-dropdown-item>
            <el-dropdown-item icon="el-icon-user-solid" @click.native="boundID()">账号绑定</el-dropdown-item>
            <!-- <el-dropdown-item icon="el-icon-s-home" @click.native="goHome()">回到首页</el-dropdown-item> -->
            <el-dropdown-item icon="el-icon-unlock" @click.native="logoutV2()">退出登录</el-dropdown-item>
            <!-- <el-dropdown-item icon="el-icon-school" v-if="tenantList.length>1" @click.native="orgChange()">切换仓库</el-dropdown-item> -->
          </el-dropdown-menu>
          <el-dropdown-menu slot="dropdown" v-else>
            <el-dropdown-item icon="el-icon-edit-outline" @click.native="setting()">修改密码</el-dropdown-item>
            <el-dropdown-item icon="el-icon-user-solid" @click.native="boundID()">账号绑定</el-dropdown-item>
            <el-dropdown-item icon="el-icon-s-home" @click.native="goHome()">回到首页</el-dropdown-item>
            <el-dropdown-item icon="el-icon-unlock" @click.native="logout()">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <el-container style="height: calc(100vh - 42px - 35px);">
      <el-aside :width="isCollapse?'64px':'170px'">
        <!-- logo -->
        <!-- <div class="logo" :class="{miniLogo:isCollapse}"></div> -->
        <!-- 导航菜单 -->
        <!-- default-active="/" 根据当路径来设置 this.$route.path -->
        <!-- this.$route 获取路由数据  this.$router 调用路由函数 -->
        <!-- 获取地址栏传参：user?id=100  this.$route.query.id  /user/100 this.$route.params.id  -->
        <div class="menuBox" v-if="createTenantCode">
          <el-menu :default-active="$route.path" class="el-menu-vertical-demo" background-color="#EBEFF0" text-color="#092A60" :collapse="isCollapse" :collapse-transition="false" router>
            <template v-for="(item) in menuList">
              <template v-if="!item.childMenu">
                <!-- 一级菜单（没有任何子级菜单）-->
                <el-menu-item :index="item.accessUrl" :route="item.accessUrl+'?menuOrBtnId='+item.id" :key="item.id" @click="menuFn(item)">
                  <i :class="item.picName"></i>
                  <span slot="title" class="menu-alert-title">
                    {{item.name}}
                    <span v-if="item.code === '00CM0Q' && videoAlertUnreadCount !== 0" class="menu-alert-count">{{videoAlertUnreadCount > 99 ? '99+' : videoAlertUnreadCount}}</span>
                  </span>
                </el-menu-item>
              </template>
              <template v-else>
                <!-- 一级菜单（有子级菜单）-->
                <el-submenu :index="item.id+''" :key="item.id">
                  <template slot="title">
                    <i :class="item.picName"></i><span slot="title">{{item.name}}</span>
                  </template>
                  <!-- 遍历二级菜单容器 -->
                  <template v-for="(i) in item.childMenu">
                    <!-- 判断二级菜单（没有三级菜单）-->
                    <template v-if="!i.childMenu">
                      <el-menu-item :index="i.accessUrl" :route="i.accessUrl+'?menuOrBtnId='+i.id" :key="i.id" @click="menuFn(i)">{{i.name}}</el-menu-item>
                    </template>
                    <template v-else>
                      <!-- 判断二级菜单（有三级菜单）-->
                      <el-submenu :index="i.id+''" :key="i.id">
                        <template slot="title"> <span slot="title">{{i.name}}</span></template>
                        <template v-for="(j) in i.childMenu">
                          <el-menu-item :index="j.accessUrl" :route="j.accessUrl+'?menuOrBtnId='+j.id" :key="j.id" @click="menuFn(j)">{{j.name}}</el-menu-item>
                        </template>
                      </el-submenu>
                    </template>
                  </template>
                </el-submenu>
              </template>
            </template>
          </el-menu>
        </div>
        <div class="menuBox" v-else>
          <el-menu :default-active="$route.path" class="el-menu-vertical-demo" background-color="#001529" text-color="#092A60" :collapse="isCollapse" :collapse-transition="false" router>
            <template v-for="(item,index) in menuList">
              <template v-if="item.childMenu.length>0">
                <el-submenu :index="index+''" :key="index">
                  <template slot="title">
                    <i :class="item.picname"></i>
                    <span slot="title">{{item.menufuncName}}</span>
                  </template>
                  <el-menu-item v-for="item in item.childMenu" :index="item.menufuncIp" :key="item.menufuncIp">
                    <i :class="item.picname"></i>
                    <span slot="title">{{item.menufuncName}}</span>
                  </el-menu-item>
                </el-submenu>
              </template>
              <template v-else>
                <el-menu-item :index="item.menufuncIp" :key="item.menufuncIp">
                  <i :class="item.picname"></i>
                  <span slot="title">{{item.menufuncName}}</span>
                </el-menu-item>
              </template>
            </template>
          </el-menu>
        </div>
        <div class="toggleMenuBox" :style="{ backgroundColor: isCollapse ? '#001529' : '#EBEFF0' }">
          <span @click="toggleMenu()" class="icon el-icon-s-fold"></span>
        </div>
      </el-aside>
      <el-container>
        <el-main class="mainBox">
          <div style="display:flex;align-items: center;min-width: 0; margin-right: 20px;"  >
            <div class="tabStyle">
              <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab" >
                <el-tab-pane
                  v-for="item in editableTabs"
                  :key="item.id"
                  :label="item.title"
                  :name="String(item.id)"
                  ></el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <!-- 二级路由对应组件渲染位置 -->
          <router-view v-if="!$route.meta.keepAlive" @msgFn="msgFn" ></router-view>
          <keep-alive v-if="isRouterAlive">
            <router-view v-if="$route.meta.keepAlive" @msgFn="msgFn" ></router-view>
          </keep-alive>
        </el-main>
        <el-dialog title="修改密码" :visible.sync="changePawDialog" width="420px" center @close="closeDialog" class="inpBox jiaoyan" :close-on-click-modal="false" :close-on-press-escape="false">
          <el-form :model="changePaw" status-icon :rules="rules" ref="changePaw" label-width="150px" class="demo-ruleForm" size="mini">
            <el-form-item label="旧密码" prop="passwordOld">
              <el-input type="password" v-model="changePaw.passwordOld" autocomplete="off" show-password></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="passwordNew">
              <el-tooltip class="item" effect="dark" content placement="top-end">
                <div slot="content">
                  长度为6-20个字符
                  <br />必须包含数字，大小写字母
                  <br />不允许有特殊字符
                </div>
                <el-input type="password" v-model="changePaw.passwordNew" autocomplete="off" show-password maxlength="20"></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <el-tooltip class="item" effect="dark" content placement="top-end">
                <div slot="content">
                  长度为6-20个字符
                  <br />必须包含数字，大小写字母
                  <br />不允许有特殊字符
                </div>
                <el-input type="password" v-model="changePaw.checkPass" autocomplete="off" show-password maxlength="20"></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('changePaw')">提交</el-button>
              <el-button @click="resetForm('changePaw')">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-container>
      <!-- <el-dialog title="账号绑定" :visible.sync="boundIDVisible" width="70%" center @close="boundIDVisible = false" :close-on-click-modal="false">
        <el-button type="primary" @click="addID">新增</el-button>
        <div style="margin-top:10px">
          <el-table border center size="mini" :data="tableData" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row height="300">
            <el-table-column label="操作" width="180">
              <template v-slot='scope'>
                <el-button type="text" @click="changeRow(scope.row)">修改</el-button>
                <el-button type="text" @click="deleteRow(scope.row)">删除</el-button>
                <el-button type="text" @click="bindRow(scope.row)" v-if="scope.row.twoway_bind == 1">授权互绑</el-button>
                <el-button type="text" @click="JCbindRow(scope.row)" v-if="scope.row.twoway_bind == 2">解除互绑</el-button>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="账号" prop="user_account"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="互绑状态" prop="twoway_bind">
              <template v-slot='scope'>
                <span v-if="scope.row.twoway_bind==1">未互绑</span>
                <span v-else>已互绑</span>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="用户名称" prop="user_name"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="租户名称" prop="tenant_name"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" label="绑定时间" prop="create_time" :formatter="dateTimeFormat"></el-table-column>
          </el-table>
        </div>
      </el-dialog> -->
      <!-- <el-dialog :title="addTitle" :visible.sync="addVisible" width="35%" center @close="addVisible = false" class="boundStyle" :close-on-click-modal="false">
        <el-form size="mini" ref="formData" label-width="150px" :model="formData" style="width: 500px; margin: 15px auto" :rules="Rules">
          <el-form-item label="登录账号：" prop="userAccount">
            <el-input size="mini" style="width:215px;" v-model="formData.userAccount" autocomplete='new-password' @change="userChange"></el-input>
          </el-form-item>
          <el-form-item label="登录密码：" prop="userPwd" style="position:relative">
            <el-input size="mini" style="width:215px;" v-model="formData.userPwd" @blur="userPwdJY(formData.userPwd)" type="password" autocomplete='new-password'></el-input>
            <span style="color:red;margin-left:5px;font-size:26px;position:absolute;" v-if="PwdShow">×</span>
            <span style="color:green;margin-left:5px;font-size:26px;position:absolute;" v-else>√</span>
          </el-form-item>
          <el-form-item label="用户名称：" prop="username">
            <el-input size="mini" style="width:215px;" v-model="formData.username" disabled></el-input>
          </el-form-item>
          <el-form-item label="租户名称：" prop="tenantName">
            <el-input size="mini" style="width:215px;" v-model="formData.tenantName" disabled></el-input>
          </el-form-item>
          <el-form-item label="手机号码：" prop="mobile">
            <el-input size="mini" style="width:120px;" v-model="formData.mobile" @blur="shoujiBlur(formData.mobile)" disabled></el-input>
            <el-button type="primary" size="mini" style="margin-left:5px" @click="sendNumber" v-if="isShowGetCode">发送验证码</el-button>
            <span v-else class="identiCode cancel-pointer" style="margin-left:5px">{{ countdown }}s后可重试</span>
          </el-form-item>
          <el-form-item label="验证码：" prop="checkCode">
            <el-input size="mini" style="width:215px;" v-model="formData.checkCode"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addVisible = false">取 消</el-button>
          <el-button type="primary" @click="addIDVisible">确 定</el-button>
        </span>
      </el-dialog> -->
      <bind-account v-if="boundIDVisible" :boundIDVisible.sync="boundIDVisible" @BindAccountList="BindAccountList"></bind-account>
    </el-container>
    <el-footer class="app-footer bgColer" height="35px">
      <div class="footer-content">
        技术支持：中物（北京）物流信息服务有限公司 &nbsp;&nbsp;| &nbsp;&nbsp;联系电话：010-59693540  &nbsp;&nbsp; | &nbsp;&nbsp; 联系地址：北京市朝阳区百子湾西里402号楼9层909 &nbsp;&nbsp; | &nbsp;&nbsp; 京ICP备15044580号-1
      </div>
    </el-footer>
  </div>
</template>

<script>
import store from '@/store'
import { loginUser, receiveMsgNoReadList, receiveMsgNoReadSum, readMsg, loginUserV2 } from '@/api/common'
import { BindAccountList } from '@/api/newCrm'
import { videoAlertUnreadNu } from '@/api/data-center-server'
import { encryption, dateTimeFormat } from '@/utils/util'
import bindAccount from './bindAccount.vue'
import Hamburger from '@/components/Hamburger'
export default {
  components: { bindAccount, Hamburger },
  data () {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.changePaw.passwordNew) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      dateTimeFormat,
      // tenantName:'',
      isCollapse: false,
      name: localStorage.getItem('userName'),
      menuList: [],
      changePawDialog: false,
      changePaw: {
        passwordOld: '',
        passwordNew: '',
        checkPass: ''
      },
      tenantName: localStorage.getItem('tenantName'),
      rules: {
        passwordOld: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        passwordNew: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '请输入至少6位的密码', trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{6,20}$/, message: '密码设置不符合要求' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' },
          { min: 6, message: '请输入至少6位的密码', trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{6,20}$/, message: '密码设置不符合要求' }
        ]
      },
      msgNum: 0,
      videoAlertUnreadCount: 0,
      videoAlertUnreadTimer: null,
      timeInterval: '1800000', // 消息定时器时长
      tiemr: null,
      notifyPromise: Promise.resolve(),
      createTenantCode: localStorage.getItem('createTenantCode'),
      createTenantName: localStorage.getItem('createTenantName'),
      tenantList: [],
      isRouterAlive: true,
      boundIDVisible: false,
      tableData: [],
      addTitle: '',
      addVisible: false,
      formData: {},
      PwdShow: true,
      phone: '',
      bindUserId: '',
      changeData: [],
      isShowGetCode: true,
      countdown: 60,
      timer: '',
      Rules: {
        userAccount: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        userPwd: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        username: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        tenantName: [
          { required: true, message: '请输入租户名称', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        checkCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      companyName: localStorage.getItem('companyName'),
      editableTabsValue: '',
      editableTabs: []
    }
  },
  provide () { return { reload: this.reload } },
  created () {
    this.getTree()
    // 切换账号
    this.BindAccountList()
    this.menuList = JSON.parse(localStorage.getItem('menuList') || '[]')
    // 修复：刷新页面时从localStorage恢复所有已打开的标签页
    let savedTabs = JSON.parse(localStorage.getItem('editableTabs') || '[]')
    let currentMenu = JSON.parse(localStorage.getItem('currentMenu') || 'null')
    // 如果localStorage中有保存的标签页，则恢复它们
    if (savedTabs && savedTabs.length > 0) {
      // 去重：基于id移除重复项
      const uniqueTabs = []
      const idSet = new Set()
      savedTabs.forEach(tab => {
        const idStr = String(tab.id)
        if (!idSet.has(idStr)) {
          idSet.add(idStr)
          uniqueTabs.push({
            ...tab,
            id: idStr
          })
        }
      })
      this.editableTabs = uniqueTabs
    }
    // 如果没有保存的标签页但有当前菜单，则创建一个标签页
    if (currentMenu) {
      const currentMenuId = String(currentMenu.id)
      // 检查是否已存在相同id的标签页
      const exists = this.editableTabs.some(tab => tab.id === currentMenuId)
      if (!exists) {
        const tabToAdd = {
          title: currentMenu.title || currentMenu.name || '未知标签',
          name: currentMenu.name,
          accessUrl: currentMenu.accessUrl,
          id: currentMenuId
        }
        this.editableTabs.push(tabToAdd)
      }
    }
    // 如果没有标签页也没有当前菜单，则创建默认首页标签页
    if (this.editableTabs.length === 0 && this.menuList && this.menuList.length > 0) {
      let defaultTab = this.getDefaultTab()
      if (defaultTab) {
        this.editableTabs.push(defaultTab)
        localStorage.setItem('currentMenu', JSON.stringify(defaultTab))
        currentMenu = defaultTab
      }
    }
    // 设置当前激活的标签页
    if (currentMenu) {
      this.editableTabsValue = String(currentMenu.id)
    } else if (this.editableTabs.length > 0) {
      // 如果没有当前菜单但有标签页，激活第一个标签页
      this.editableTabsValue = this.editableTabs[0].id
    }
    // 保存标签页到localStorage
    this.saveTabsToStorage()
  },
  methods: {
    // 获取默认标签页
    getDefaultTab () {
      if (!this.menuList || this.menuList.length === 0) return null

      let menuItem = null
      let menuList = this.menuList

      // 递归查找第一个有访问路径的菜单项
      function findFirstAccessibleMenu (menus) {
        for (let item of menus) {
          if (item.accessUrl && item.accessUrl !== '#') {
            return item
          }
          if (item.childMenu && item.childMenu.length > 0) {
            let childResult = findFirstAccessibleMenu(item.childMenu)
            if (childResult) return childResult
          }
        }
        return null
      }

      menuItem = findFirstAccessibleMenu(menuList)

      if (menuItem) {
        return {
          title: menuItem.title || menuItem.name || '未知标签',
          name: menuItem.name,
          accessUrl: menuItem.accessUrl,
          id: String(menuItem.id)
        }
      }

      return null
    },
    // 保存标签页到localStorage
    saveTabsToStorage () {
      // 确保存储前数据是干净的
      const cleanTabs = this.editableTabs.map(tab => ({
        title: tab.title,
        name: tab.name,
        accessUrl: tab.accessUrl,
        id: String(tab.id)
      }))
      localStorage.setItem('editableTabs', JSON.stringify(cleanTabs))
    },
    editableTabFn (data) {
      console.log(data, 'tab菜单')
      const tabId = String(data.id)
      let flag = this.editableTabs.some(item => item.id === tabId)
      if (!flag) {
        const tabData = {
          title: data.title || data.name || '未知标签',
          name: data.name,
          accessUrl: data.accessUrl,
          id: tabId
        }
        this.editableTabs.push(tabData)
      }
      localStorage.setItem('currentMenu', JSON.stringify({
        title: data.title || data.name || '未知标签',
        name: data.name,
        accessUrl: data.accessUrl,
        id: tabId
      }))
      // console.log(data, '每次点击')
      this.editableTabsValue = tabId
      this.saveTabsToStorage()
    },
    clickTab (e) {
      const tab = this.editableTabs[e.index]
      localStorage.setItem('currentMenu', JSON.stringify(tab))
      this.$router.push({
        path: tab.accessUrl,
        query: { menuOrBtnId: tab.id } // 始终携带唯一id
      })
    },
    menuFn (menuData) {
      // 确保 id 转换为字符串类型进行比较
      const menuId = String(menuData.id)
      // 检查是否已存在相同 id 的标签页
      const exists = this.editableTabs.some(item => String(item.id) === menuId)
      if (!exists) {
        const newTab = {
          title: menuData.title || menuData.name || '未知标签',
          name: menuData.name,
          accessUrl: menuData.accessUrl,
          id: menuId
        }
        this.editableTabs.push(newTab)
      }
      // 更新当前菜单和激活的标签页
      const currentMenuData = {
        title: menuData.title || menuData.name || '未知标签',
        name: menuData.name,
        accessUrl: menuData.accessUrl,
        id: menuId
      }
      localStorage.setItem('currentMenu', JSON.stringify(currentMenuData))
      this.editableTabsValue = menuId
      this.saveTabsToStorage()
      this.$router.push({ path: menuData.accessUrl, query: { menuOrBtnId: menuId } })
    },
    removeTab (targetID) {
      let tabs = this.editableTabs
      // 找到要删除标签的索引
      const targetIndex = tabs.findIndex(tab => tab.id === targetID)
      // 寻找下一个激活的标签
      let nextTab = tabs[targetIndex + 1] || tabs[targetIndex - 1]
      if (nextTab) {
        this.editableTabsValue = String(nextTab.id)
        localStorage.setItem('currentMenu', JSON.stringify(nextTab))
        this.$router.push({
          path: nextTab.accessUrl,
          query: { menuOrBtnId: nextTab.id }
        })
      }
      // 正确过滤：只删除指定id的标签
      this.editableTabs = tabs.filter(tab => tab.id !== targetID)
      this.saveTabsToStorage() // 保存标签页
    },
    getTree () {
      if (localStorage.getItem('tenantList')) {
        this.tenantList = JSON.parse(localStorage.getItem('tenantList'))
      }
      this.getMsg()
      this.tiemr = setInterval(this.getMsg, this.timeInterval)
      // if (localStorage.getItem('isCutCrm3') == 1) {
      console.log(this.createTenantCode)
      if (this.createTenantCode) {
        document.title = this.tenantName
        const loading = this.$loading({
          lock: true,
          text: '正在加载...'
        })
        let params = {}
        if (localStorage.getItem('isBusiness') == 1) {
          params = { businessId: localStorage.getItem('createTenantCode') }
        } else {
          params = { tenantCode: localStorage.getItem('createTenantCode') }
        }
        this.$axios({
          method: 'post',
          url: this.global.commonNameV2 + '/user/rightTree',
          params: params
        }).then(res => {
          loading.close()
          localStorage.setItem('menuList', res.data)
          this.menuList = JSON.parse(res.data)
          let menuList = JSON.parse(res.data)
          if (this.hasMenuCode(menuList, '00CM0Q')) {
            this.startVideoAlertUnreadTimer()
          } else {
            this.clearVideoAlertUnreadTimer()
          }
          if (!store.getIp()) {
            if (menuList[0].childMenu) { // 判断一级下面有没有二级
              if (menuList[0].childMenu[0].childMenu) { // 判断二级下面有没有子集
                store.setIp(menuList[0].childMenu[0].childMenu[0].accessUrl + '?menuOrBtnId=' + menuList[0].childMenu[0].childMenu[0].id)
                this.$router.push({ path: menuList[0].childMenu[0].childMenu[0].accessUrl, query: { menuOrBtnId: menuList[0].childMenu[0].childMenu[0].id } })
                let menuData = menuList[0].childMenu[0].childMenu[0]
                this.editableTabs.push({
                  title: menuData.title || menuData.name || '未知标签',
                  name: menuData.name,
                  accessUrl: menuData.accessUrl,
                  id: String(menuData.id)
                })
                this.editableTabsValue = String(menuData.id)
                this.saveTabsToStorage()
              } else {
                store.setIp(menuList[0].childMenu[0].accessUrl + '?menuOrBtnId=' + menuList[0].childMenu[0].id)
                this.$router.push({ path: menuList[0].childMenu[0].accessUrl, query: { menuOrBtnId: menuList[0].childMenu[0].id } })
                let menuData = menuList[0].childMenu[0]
                this.editableTabs.push({
                  title: menuData.title || menuData.name || '未知标签',
                  name: menuData.name,
                  accessUrl: menuData.accessUrl,
                  id: String(menuData.id)
                })
                this.editableTabsValue = String(menuData.id)
                this.saveTabsToStorage()
              }
            } else { // 一级下面没有子菜单
              store.setIp(menuList[0].accessUrl + '?menuOrBtnId=' + menuList[0].id)
              this.$router.push({ path: menuList[0].accessUrl, query: { menuOrBtnId: menuList[0].id } })
              let menuData = menuList[0]
              this.editableTabs.push({
                title: menuData.title || menuData.name || '未知标签',
                name: menuData.name,
                accessUrl: menuData.accessUrl,
                id: String(menuData.id)
              })
              this.editableTabsValue = String(menuData.id)
              this.saveTabsToStorage()
            }
          }
          // menuList.forEach(item => {
          //   if (item.childMenu) { // 判断一级下面有没有二级
          //     item.childMenu.forEach(i => {
          //       if (i.childMenu) { // 判断二级下面有没有子集
          //         i.childMenu.forEach(j => {
          //           setBtnFn(j)
          //         })
          //       } else {
          //         setBtnFn(i)
          //       }
          //     })
          //   } else { // 一级下面没有子菜单
          //     setBtnFn(item)
          //   }
          // })
          // function setBtnFn (data) {
          //   if (data.buttonDetails.length > 0) {
          //     localStorage.setItem(data.accessUrl, JSON.stringify(data.buttonDetails))
          //   }
          // }
        }).catch(error => {
          this.$message.error(error.msg)
        })
      } else {
        this.orgChange()
      }
      // } else {
      //   this.loginUserV2()
      // }
    },
    loginUserV2 () {
      loginUserV2().then(res => {
        document.title = res.tenantName
        localStorage.setItem('mobile', res.mobile)
        localStorage.setItem('userCode', res.userCode)
        localStorage.setItem('userName', res.userName)
        localStorage.setItem('tenantName', res.tenantName)
        localStorage.setItem('tenantCode', res.tenantCode)
        localStorage.setItem('registerId', res.userId)
        localStorage.setItem('businessFlg', res.businessFlg)
        localStorage.setItem('tenantTaxpayerNumber', res.tenantTaxpayerNumber)
        localStorage.setItem('isAdmin', res.isAdmin)
        localStorage.setItem('orgName', res.orgName)
        localStorage.setItem('orgCode', res.orgCode)
        localStorage.setItem('dataLevel', res.dataLevel)
        localStorage.setItem('companyName', res.companyName)
        localStorage.setItem('companyCode', res.companyCode)
        localStorage.setItem('orgSubCode', res.orgSubCode)
        localStorage.setItem('orgSubName', res.orgSubName)
        this.tenantName = localStorage.getItem('tenantName')
        this.name = localStorage.getItem('userName')
        if (res.businessList) {
          res.businessList.forEach(item => {
            res.tenantList.push({ tenantCode: item.businessId, businessCode: item.businessCode, tenantName: item.businessName, flag: true })
          })
        }
        if (res.tenantList.length == 1) {
          localStorage.setItem('isBusiness', res.businessList && res.businessList.length == 1 ? 1 : 2)
          localStorage.setItem('createTenantCode', res.tenantList[0].tenantCode)
          localStorage.setItem('createTenantName', res.tenantList[0].tenantName)
        } else if (res.tenantList.length > 1) {
          localStorage.setItem('tenantList', JSON.stringify(res.tenantList))
          this.$router.push({ path: '/selectOrg' })
        } else {
          this.$message.error('该账号无操作权限！')
        }
        this.createTenantCode = localStorage.getItem('createTenantCode')
        this.getTree()
        BindAccountList().then(res => {
          console.log(res)
          this.changeData = res
        })
          .catch(error => {
            this.$message.error(error.message)
          })
      })
    },
    BindAccountList () {
      BindAccountList().then(res => {
        console.log(res)
        this.changeData = res
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 切换账号
    changeID (val) {
      this.$confirm('确认切换账号吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        console.log(store.getUser(), 'store.getUser()')
        this.$axios({
          headers: {
            Authorization: 'Bearer ' + store.getUser().access_token
          },
          method: 'post',
          url: this.global.commonNameV2 + '/oauth/token',
          params: {
            grant_type: 'cut_account',
            bindUserId: val
          }
        }).then(res => {
          console.log(res)
          store.delUser()
          store.setUser(res.data)
          localStorage.clear()
          sessionStorage.clear()
          localStorage.setItem('isCutCrm3', res.data.isCutCrm3)
          this.editableTabs = []
          this.loginUserV2()
        })
          .catch(error => {
            this.$message.error(error.message)
          })
      })
        .catch(error => {
          console.log(error)
        })
    },
    boundID () {
      this.boundIDVisible = true
    },

    // 解决keep-alive缓存问
    reload () {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    },
    // 切换仓库
    orgChange () {
      this.$router.push({ path: '/selectOrg' })
    },
    msgFn (data) {
      this.msgNum = data
    },
    getMsg () {
      receiveMsgNoReadList({
        timeInterval: this.timeInterval,
        userType: 1
      }).then(res => {
        res.forEach(item => {
          this.notify(item)
        })
      })
      receiveMsgNoReadSum({
        userType: 1
      }).then(res => {
        this.msgNum = res
      })
    },
    notify (item) {
      let that = this
      this.notifyPromise = this.notifyPromise.then(this.$nextTick).then(() => {
        const notificationInstance = this.$notify({
          title: item.messageTitle,
          // dangerouslyUseHTMLString: true,
          message: item.messageContent,
          position: 'bottom-right',
          duration: 60000,
          customClass: 'notifyBeijing',
          onClick: function () {
            if (item.messageClassify == 2) {
              readMsg({ messageId: item.id, userType: 1 }).then(res => {
                receiveMsgNoReadSum({
                  userType: 1
                }).then(res => {
                  that.msgNum = res
                  that.$router.push({ name: 'qiYunOrder', params: { orderNo: item.messageKey } })
                })
              })
            } else {
              that.$router.push({ name: 'messageLook', query: { id: item.id } })
            }
            notificationInstance.close()
          }
        })
      })
    },
    xiaoxiFn () {
      this.$router.push('/messageNotification')
    },
    // el-dropdown-item 绑定事件  不支持click
    // 当你给组件绑定事件的时候，如果组件没有支持这个事件，当然不会触发。
    // click是原生dom拥有的事件，目的给组件渲染后的dom绑定事件
    // 事件修饰符，例如 @click.prevent="函数"  阻止默认行为  @click.native 把原生事件绑定在组件上
    // https://cn.vuejs.org/v2/guide/events.html#%E4%BA%8B%E4%BB%B6%E4%BF%AE%E9%A5%B0%E7%AC%A6
    // 消息公告
    // 去设置页面
    getData () {
      return function () { }
    },
    setting () {
      this.changePawDialog = true
    },
    // 回到首页
    goHome () {
      // this.$router.push('/website')
      window.open('http://www.zw56.com')
    },
    // 退出登录
    logout () {
      this.$axios
        .get(this.global.commonName + '/oauth/remove/token')
        .then(res => {
          store.delUser()
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push('/login')
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
    },
    // 退出登录
    logoutV2 () {
      this.$axios
        .get(this.global.commonNameV2 + '/oauth/remove/token')
        .then(res => {
          store.delUser()
          localStorage.clear()
          sessionStorage.clear()
          this.$router.push('/login')
        })
        .catch(error => {
          this.$message.error(error.msg)
        })
    },
    // 修改密码 适用v1和v2
    submitForm (formName) {
      let data = encryption({
        data: this.changePaw,
        key: this.global.key,
        param: ['passwordOld', 'passwordNew']
      })
      let data1 = {
        passwordOld: data.passwordOld,
        passwordNew: data.passwordNew
      }
      let url = ''
      if (this.createTenantCode) { // 判断那个版本修改密码
        url = this.global.commonNameV2
      } else {
        url = this.global.commonName
      }
      // console.log(data1)
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios({
            method: 'post',
            url: url + '/user/changePwd',
            params: data1
          })
            .then(res => {
              this.$message('修改密码成功请重新登录')
              this.logout()
            }).catch(error => {
              console.log(error)
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                }
              })
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    toggleMenu () {
      // 切换侧边栏展开与收起
      // 数据 isCollapse 默认值false 展开意思
      // 通过这个数据的状态去切换 侧边栏展开与收起 状态
      this.isCollapse = !this.isCollapse
    },
    closeDialog () {
      this.$refs.changePaw.resetFields()
    },
    // 获取智能预警未读数
    hasMenuCode (menuList, code) {
      return menuList.some(item => {
        if (item.code === code) return true
        return item.childMenu && this.hasMenuCode(item.childMenu, code)
      })
    },
    startVideoAlertUnreadTimer () {
      this.clearVideoAlertUnreadTimer()
      this.getVideoAlertUnreadCount()
      this.videoAlertUnreadTimer = setInterval(() => {
        this.getVideoAlertUnreadCount()
      }, 5 * 60 * 1000)
    },
    clearVideoAlertUnreadTimer () {
      if (this.videoAlertUnreadTimer) {
        clearInterval(this.videoAlertUnreadTimer)
        this.videoAlertUnreadTimer = null
      }
    },
    getVideoAlertUnreadCount () {
      videoAlertUnreadNu({
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        console.log('智能预警未读数接口返回：', res)
        const result = res && res.data !== undefined ? res.data : res
        const count = typeof result === 'object' && result !== null
          ? result.count !== undefined ? result.count
            : result.unreadCount !== undefined ? result.unreadCount
              : result.unreadNum !== undefined ? result.unreadNum
                : result.videoAlertUnreadNu
          : result
        const numberCount = Number(count)
        this.videoAlertUnreadCount = Number.isFinite(numberCount) && numberCount > 0 ? numberCount : 0
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    }

  },
  destroyed () {
    clearInterval(this.tiemr)
    clearInterval(this.timer)
    this.clearVideoAlertUnreadTimer()
  }
}
</script>

<style lang='less'>
// FE  front end  前端工程师
// el-container 自定义标签是一个组件  渲染后的结构div span section  默认在标签上架上一个和组件名称一致的类名
body {
  overflow: hidden; /* 防止body出现滚动条 */
  background-color: #e5e5e5;
  margin: 0;
  padding: 0;
}
.searchBtnBox {
  padding-left: 10px;
  margin: 10px 0;
}

.home-container {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .el-aside {
    background: #ebeff0;
    position: relative;
    overflow: hidden;
    transition: all .4s ease;
    // box-shadow: 2px 0 6px rgba(0,21,41,.35);
    .menuBox {
      height: calc(100vh - 120px);
      overflow: auto;
      padding-bottom: 50px;
      overflow-y: auto; /* 允许垂直滚动 */
      &::-webkit-scrollbar {
        /* 隐藏滚动条 */
        width: 0 !important;
        height: 0 !important;
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: transparent;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
       /* 兼容Firefox */
      scrollbar-width: none;
      -ms-overflow-style: none;  /* IE 10+ */
    }
    // 后面样式覆盖前面
    .miniLogo {
      background-image: url(../../../assets/images/logo_admin_01.png);
      background-size: 36px auto;
    }
    .el-menu {
      border-right: none;
    }
    .el-menu-item {
      height: 42px;
      line-height: 42px;
    }
    .menu-alert-title {
      position: relative;
      display: inline-block;
    }
    .menu-alert-count {
      position: absolute;
      top: 12px;
      left: calc(100% + 6px);
      min-width: 18px;
      height: 18px;
      padding: 0 5px;
      border-radius: 9px;
      box-sizing: border-box;
      background-color: #f34242;
      color: #fff;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
    }
    .el-submenu .el-menu-item {
      min-width: 100px;
    }
    .el-menu .fa {
      margin-right: 8px;
      color: #0c46a2;
    }
    .el-menu-item,
    .el-submenu__title {
      height: 42px;
      line-height: 42px;
    }

    .submenuBox .el-menu-item {
      background-color: #0c46a2 !important;
    }
    .el-menu-item.is-active {
      background: #0c46a2 !important;
      color: #fff;
    }
    .el-menu-item.is-active i {
      color: #fff !important;
    }
    .el-submenu__title:hover {
      background: #EBEFF0 !important;
      color: #0c46a2 !important;
      i {
        color: #0c46a2 !important; /* 图标保持默认颜色 */
      }
      .el-submenu__icon-arrow {
        color: #0c46a2 !important; /* 箭头图标保持默认颜色 */
      }
    }
    /* 确保子菜单标题选中状态也有正确样式 */
    .el-submenu.is-active > .el-submenu__title {
      color: #0c46a2 !important;
      background: #EBEFF0 !important; /* 选中时不改变背景 */

      i {
        color: #0c46a2 !important;
      }

      .el-submenu__icon-arrow {
        color: #0c46a2 !important;
      }
    }
    .el-submenu.is-active > .el-submenu__title i {
      color: #0c46a2 !important; /* 保持原色 */
    }
    /* 保持子菜单项的悬浮效果不变 */
    .el-menu-item:hover,
    .el-menu-item.is-active:hover {
      background: #396bbc !important;
      color: #fff !important;

      i {
        color: #fff !important;
      }
    }
    .el-menu-item:hover i,
    .el-menu-item.is-active:hover i {
      color: #fff !important;
    }
    /* 修改箭头图标颜色为蓝色 */
    .el-submenu__title .el-icon-arrow-down {
        color: #0c46a2 !important;
    }

    /* 确保悬浮时箭头也保持蓝色 */
    .el-submenu__title:hover .el-submenu__icon-arrow {
        color: #0c46a2 !important;
    }

    /* 确保选中状态时箭头保持蓝色 */
    .el-submenu.is-active > .el-submenu__title .el-submenu__icon-arrow {
        color: #0c46a2 !important;
    }
    .toggleMenuBox {
      text-align: center;
      width: 100%;
      position: absolute;
      color: #0c46a2;
      bottom: 0px;
      padding: 0px 0 20px;
      transition: background-color 0.3s;
      z-index: 1; /* 确保按钮在上层 */
    }
    /* 确保收起状态下按钮颜色与深色菜单一致 */
    .home-container .el-aside .toggleMenuBox {
      background-color: #ebeff0; /* 默认展开状态的背景色 */
    }

    .home-container .el-aside .menuBox + .toggleMenuBox {
      background-color: inherit; /* 继承父元素背景色 */
    }
  }
  .el-header > div:first-child {
    width:100%;
  }
  .el-submenu__icon-arrow {
    margin-top: -5px;
  }
  .el-header {
    // background-color: #0c46a2;
    flex-shrink: 0; /* 禁止头部收缩 */
    height: 42px;
    line-height: 42px;
    z-index: 10;
    .icon {
      font-size: 24px;
      vertical-align: middle;
      padding-right: 10px;
    }
    .text {
      font-family: Source Han Sans CN;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 37px;
      color: #fff;
      // color: #333;
    }
    .headerRight {
      flex-shrink: 0; /* 防止右侧被压缩 */
      white-space: nowrap; /* 防止右侧内容换行 */
      padding-left: 30px;
      // box-shadow: -10px 0 10px -5px rgba(255,255,255,0.9); /* 左侧渐变遮罩 */
      // float: right;
      display: flex;
      top: 0;
      height: 42px;
      align-items: center;
      .mesbox {
        display: flex;
        margin-right: 8px;
        align-items: center;
      }
      .el-badge__content {
        top: 8px;
        border: none;
      }
      .el-icon-message-solid {
        font-size: 14px;
        margin-right: 4px;
      }
      .avatar {
        width: 25px;
        height: 25px;
        vertical-align: middle;
        display: inline-block;
      }
      .username {
        color: #fff;
        vertical-align: middle;
        font-size: 12px;
        margin-left: 4px;
        cursor: pointer;
      }
      .el-icon-arrow-down {
        color: #fff;
      }
      .ID-dropdown {
        .el-i-down {
          transform: rotate(90deg);
          color: #fff;
          font-size: 14px;
          margin-right: 4px;
        }
        .ID-change {
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }
}
.el-submenu__title i {
  color: #fff;
}

.footerBtn {
  text-align: center;
  padding: 20px;
}
.dialogInp {
  background: #dbe5ef;
  padding: 20px 0;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
}
.diqu1 {
  .el-form-item__content {
    .el-input__inner {
      width: 460px;
    }
  }
}
.jiage .el-form-item__content {
  position: relative;
  .danwei {
    position: absolute;
    right: 4px;
    color: #9c9797;
  }
}

.el-table td,
.el-table th {
  padding: 2px 0 !important;
}
.el-main {
  height: calc(100vh - 42px - 35px);
  background: #DCECFB;
  padding: 10px !important;
  // padding: 0;
  padding-bottom: 0 !important;
  // padding-top: 12px;
}
.inpBox .el-input__inner {
  width: 150px;
}
.remark .el-input .el-input__inner {
  width: 480px;
}
.gjh {
  height: 60px;
}
.gjh .el-input__inner {
  height: 100%;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 6px;
}
.jiaoyan .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 16px !important;
}
.searchBox {
  display: flex;
}
.searchBox .gjhBox .el-form-item {
  display: flex;
}
.gjhBox {
  flex-shrink: 0;
}
.gjhBox /deep/.el-textarea__inner {
  width: 150px;
  height: 60px;
}

.margin0 {
  margin: 0 !important;
}
.red {
  color: #ff0000;
  font-size: 14px;
  margin: 0 4px;
  font-family: Source Han Sans CN;
}
.el-dialog .el-dialog__body {
  padding: 10px 20px;
}
.el-input.is-disabled .el-input__inner {
  border: none;
  background: #dcedff;
}

// 按钮样式
.el-button--primary {
  background-color: #0c46a2;
}
.el-button--primary:focus,
.el-button--primary:hover {
  background: #0b59bd;
  border-color: #0b59bd;
  color: #fff;
}
.el-button {
  padding: 7px 15px;
}
.el-button--text {
  padding: 0;
}
.bigBtn {
  padding: 12px 28px;
}
.el-button--text {
  color: #0c46a2;
  // color: #0c46a2
}
.el-button--text:focus,
.el-button--text:hover {
  color: #0b59bd;
}
// 表格样式
.el-table th {
  background-color: #f5f5f5;
  height: 40px;
  color: #333333;
}
.el-table {
  color: #333;
}
.el-table tr {
  height: 32px;
}
.el-table tr:nth-child(even) {
  background-color: #f8fafd;
}
.el-table__body tr.hover-row > td {
  background-color: rgba(14, 110, 236, 0.2) !important;
}
.el-table__body tr.current-row > td {
  background-color: rgba(14, 110, 236, 0.2) !important;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(14, 110, 236, 0.2) !important;
}
// .el-table__body tr:hover {
//   background-color: rgba(14, 110, 236, 0.3) !important;
// }
.el-table .cell {
  text-align: center;
}

//表单颜色
.el-form-item__label {
  color: #333;
}
// 弹框样式
.el-message-box__header {
  border-bottom: 1px solid #dcdfe6;
}
.el-message-box__title {
  font-size: 16px;
  color: #333;
}
.el-message-box__content {
  color: #333;
}
.el-dialog__headerbtn {
  top: 12px;
  .el-dialog__close {
    color: #fff;
  }
}
.el-dialog__title {
  color: #fff;
}
.el-dialog__header {
  padding: 8px 20px;
  background-color: #0c46a2;
  border-radius: 4px 4px 0 0;
}
.el-dialog--center {
  border-radius: 4px 4px 0 0;
}
//发布货源
.addressBox {
  .title {
    margin-top: 0;
    margin-left: 10px;
    font-size: 16px;
    .iconFont {
      color: #0c46a2;
    }
  }
  .el-button--text {
    padding: 0;
    margin: 0 4px;
  }
}
hr {
  width: 100%;
  height: 1px;
  border: none;
  border-top: dashed 1px #dcdfe6;
}
.el-form--inline .diqu {
  display: flex;
  .el-form-item__content {
    display: flex;
    flex-direction: column;
    .el-input__inner {
      width: 240px;
    }
  }
}
.iconFont {
  margin-right: 4px;
  font-size: 14px;
}
.el-date-editor.el-input {
  width: auto;
}
.inpBox .el-date-editor .el-input__inner {
  width: 180px;
}
.el-upload--picture-card {
  background-image: url(../../../assets/images/upload.png);
  background-size: 150%;
  background-position: 50% 50%;
}
.disabled .el-input__inner {
  background: #dcedff;
}
// 详情页title
.detailsTitle {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 10px;
  padding-top: 10px;
  h4 {
    margin: 0;
    font-size: 16px;
    color: #333;
    padding-bottom: 10px;
    border-bottom: 2px solid #0c46a2;
  }
  .printBox h4 {
    display: inline-block;
    margin-right: 20px;
  }
  .fa-reply {
    padding-right: 10px;
    color: #0c46a2;
  }
}
body.el-loading-parent--relative {
  position: static !important;
}
.mar10 {
  margin-left: 10px;
}
// 提单详情
.ydxq {
  display: flex;
  color: #fff;
  background: #4894f6;
  margin: 0;
  flex-wrap: wrap;
  padding-left: 10px;
}
// 抽屉样式
.el-drawer__header {
  height: 40px;
  background: #0c46a2;
  padding: 0 0 0 10px;
  color: #fff;
  margin: 0;
}
.el-drawer__body {
  overflow: auto;
  padding-bottom: 48px;
}
.footerBox {
  text-align: center;
  position: absolute;
  bottom: 0px;
  width: 100%;
  padding: 10px;
  background: #fff;
}
.leftDrawer {
  width: 50%;
}
.rightDrawer {
  width: 50%;
  right: 0;
  left: auto;
}
.BtnBox {
  display: flex;
  margin: 10px;
  .el-button {
    margin-left: 8px;
  }
}
// 表格错位问题
body .el-table th.gutter:last-of-type {
  display: block !important;
  width: 17px !important;
}
// 运单的车辆监控
.vehm .el-dialog__body {
  padding: 0;
}
.amap-icon img {
  width: 32px;
  height: 32px;
}
.amap-sug-result {
  z-index: 999999;
}
.is-need:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.el-table__empty-block {
  align-items: stretch !important;
}
.el-cascader-node > .el-radio {
  visibility: hidden !important;
}
.detail .box1 span {
  font-size: 14px !important;
}
.detail .el-date-editor .el-input__inner {
  font-size: 14px !important;
}
.timmHH .el-time-panel {
  //解决时间选择器需要选择到时
  display: none;
}
.boundStyle .el-form-item--mini.el-form-item {
  margin-bottom: 20px !important;
}
.wsStyle{
  color:#f52020;
}
.bfStyle{
  color:#03aadf;
}
.ysStyle{
  color:#3e8804;
}
.el-notification__group {
  cursor: pointer;
}
.notifyBeijing{
  background: #c4e1ff;
}
.tabStyle{
  flex: 1;
  min-width: 0; /* 关键：允许内容收缩 */
  overflow-x: auto;
  // margin-right: 160px; /* 留出右侧用户信息空间 */
  // height: 50px; /* 固定高度防止纵向滚动 */
  /* 隐藏原生滚动条 */
  &::-webkit-scrollbar {
    display: none;
  }
}
.tabStyle .el-tabs__nav {
  min-width: 100%;
  transition: transform 0.3s;
}
.tabStyle .el-tabs__nav-scroll {
  overflow: hidden !important; /* 恢复element默认处理 */
  display: block !important; /* 恢复块级布局 */
  margin-bottom: 0 !important;
}
.tabStyle .el-tabs__item {
  margin-right: 4px !important;
  flex-shrink: 0; /* 禁止标签项收缩 */
}
.tabStyle .el-tabs__nav-wrap::after {
  display: none !important; /* 隐藏默认的下划线 */
}
.tabStyle .el-tabs__nav .el-tabs__item:nth-child(1) span{
  display: none;
}
.tabStyle .el-tabs__item.is-active{
  background: #0c46a2;   //#f4f4f4
  color: #ffff;
}
.tabStyle .el-tabs__item{
  height: 32px !important;
  line-height: 32px !important;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background: #f4f4f4;
}
.tabStyle .el-tabs--card>.el-tabs__header .el-tabs__nav{
  border: none!important;
}
.tabStyle .el-tabs__nav-next, .el-tabs__nav-prev {
  line-height: 30px !important;
}
.tabStyle .el-tabs--card>.el-tabs__header .el-tabs__item:first-child {
  border-left: none!important;
  border-right: none!important;
}
.tabStyle .el-tabs__header{
  margin:0!important;
}
.tabStyle .el-tabs__item:hover{
  color: #fff;
   background: #0c46a2;
}
.textStyle{
  display: flex;
  font-size: 12px;
  color: #0c46a2;
  cursor: pointer;
  white-space: nowrap;
}
.expand-btn-wrapper {
  margin-right: 20px;
}
.app-footer {
  flex-shrink: 0; /* 禁止底部收缩 */
  color: #fff;
  height: 35px;
  line-height: 35px;
  text-align: center;
  font-size: 12px;
  font-family: Source Han Sans CN;
  z-index: 10;
  .footer-content {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
}
.menuBox .el-submenu__title i{
  color: #0c46a2;
}
.menuBox .el-menu-item i{
  color: #0c46a2;
}
</style>
